var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fullview"},[_c('div',{staticClass:"loading-spacer"}),_vm._v(" "),_c('vue-loading',{attrs:{"type":"spiningDubbles","color":"#5cd5d6","size":{ width: '50vw' }}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("通信中です")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5295bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/Loading.vue
// module id = null
// module chunks = 